import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { ExportSettingsProps } from "."
import { ExportParametersTab } from "./tabs/ExportParametersTab"
import { ParametersOverviewTab } from "./tabs/ParametersOverviewTab"

export function ExportSettings({ exportData, columnVisibility, setColumnVisibility }: ExportSettingsProps) {
    return (
        <div className="">
            <Tabs defaultValue="parametersOverview" className="w-full">
                <TabsList className="grid w-full grid-cols-2">
                    <TabsTrigger value="parametersOverview">Parameters Overview</TabsTrigger>
                    <TabsTrigger value="exportParameters">Export Parameters</TabsTrigger>
                </TabsList>
                <TabsContent value="parametersOverview">
                    <ParametersOverviewTab exportData={exportData} />
                </TabsContent>
                <TabsContent value="exportParameters">
                    <ExportParametersTab
                        exportData={exportData}
                        columnVisibility={columnVisibility}
                        setColumnVisibility={setColumnVisibility}
                    />
                </TabsContent>
            </Tabs>
        </div>
    )
}



